import dayjs from "dayjs";

const damageReportConverter = {
    convertIn: (responseData) => {
        if (responseData.date) {
            responseData.date = dayjs(responseData.date);
        }

        if (responseData.createdAt) {
            responseData.createdAt = dayjs(responseData.createdAt);
        }

        if (responseData.updatedAt) {
            responseData.updatedAt = dayjs(responseData.updatedAt);
        }

        return responseData;
    },
    convertOut: ({ rental, responsibleUser, sku, id, ...rest }) => {
        return {
            ...rest,
            ...(sku?.id && {
                sku: sku.id,
            }),
            ...(responsibleUser && {
                responsibleUser: responsibleUser.id,
            }),
            ...(rental && {
                rental: rental.id,
            }),
        };
    },
};

export default damageReportConverter;
